/* eslint-disable */
import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'

import debug from 'debug'

let installed = false

const isTracked = [
  'production',
  'verification',
  'development',
  'integration',
  'unknown_env',
]

const getGlobals = () => ({
  environment: process.env.REACT_APP_EXCEPTION_TRACKING_ENV || 'unknown_env',
  token: process.env.REACT_APP_EXCEPTION_TRACKING_TOKEN,
  release: process.env.REACT_APP_RELEASE,
})

const getSentryConfig = (env, release) => ({
  environment: env,
  release: release,
  integrations: [new BrowserTracing()],

  autoBreadcrumbs: {
    console: false,
    dom: true,
    location: true,
    xhr: false,
    sentry: true,
  },
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.5,
})

// ---------------------------------------------------------------------------

function _init(Sentry, debug) {
  return function () {
    const { environment, token, release } = getGlobals()

    if (!installed && isTracked.includes(environment)) {
      const dsn = { dsn: token }
      const config = getSentryConfig(environment, release)

      Sentry.init({
        ...dsn,
        ...getSentryConfig(environment, release),
      })

      installed = true

      debug('BLINKER:exception')('Exception tracking initialized')
    }
  }
}

function _setUser(Sentry, debug) {
  return function (sentryUserContext: object | undefined = undefined) {
    const { environment } = getGlobals()

    if (isTracked.includes(environment)) {
      Sentry.setUser(sentryUserContext)

      debug('BLINKER:exception')('Exception tracking user context set')
    }
  }
}

function _capture(Sentry) {
  return function (err) {
    Sentry.withScope((scope) => {
      scope.setExtras('debug', true)
      Sentry.captureException(err)
    })
  }
}

// ---------------------------------------------------------------------------

export default {
  capture: _capture(Sentry),
  init: _init(Sentry, debug),
  setUser: _setUser(Sentry, debug),
  defaulConfig: getSentryConfig,
}

export const Test = {
  _capture,
  _init,
  _setUser,
}
